import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MonitoringSpeedService } from './monitoring-speed.service';
import { Observable, of } from 'rxjs';
import { ICartesianSeries, SeriesTypes, themeTypeToCssVar } from '@activia/dataviz';
import { ThemeType } from '@activia/ngx-components';
import { ServerOverviewService } from '../server/server-overview.service';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'amp-monitoring-speed',
  templateUrl: './monitoring-speed.component.html',
  styleUrls: ['./monitoring-speed.component.scss'],
})
export class MonitoringSpeedComponent implements OnInit, OnDestroy {
  @Input() valueFormatter: (val: number) => number;

  series: Array<ICartesianSeries>;
  data$: Observable<Array<ICartesianSeries> | string>;

  constructor(private translateService: TranslocoService, private monitoringSpeedService: MonitoringSpeedService) {
    this.monitoringSpeedService.start();

    this.series = [
      {
        key: this.translateService.translate('dashboardScope.dashboard.monitoring-speed.label'),
        name: this.translateService.translate('dashboardScope.dashboard.monitoring-speed.label'),
        type: SeriesTypes.AREA_LINE,
        color: themeTypeToCssVar(ThemeType.PRIMARY),
        lineWidth: 1,
        areaFillOpacity: 0.5,
        data: [],
        maxDataItems: ServerOverviewService.dataSetLimit,
      },
    ];
  }

  ngOnInit(): void {
    this.data$ = this.monitoringSpeedService.monitoringSpeed$.pipe(
      map((monitoringSpeed) => {
        this.series = this.series.map((serie) => ({
            ...serie,
            data: [
              ...serie.data,
              {
                x: monitoringSpeed.x,
                y: this.valueFormatter ? this.valueFormatter(monitoringSpeed.y) : monitoringSpeed.y,
              },
            ],
          }));
        return this.series;
      }),
      catchError((error: string) => of(error))
    );
  }

  /**
   * @ignore
   */
  ngOnDestroy(): void {
    this.monitoringSpeedService.stop();
  }
}
